module.exports = __webpack_public_path__ + "static/media/퇴뫼산곱돌산.aa7bd98c.jpg";